import axios from 'axios';
import AccessiService from '../Accessi/AccessiApi.js';
import AutenticationService from '../../authservice.js';
//../Accessi/AccessiApi.js
class UtentiService {
  state = {
    BaseUrl: '/utenti',
  };
  getUtentiUrl = () => {
    return `${AccessiService.getUrl()}${this.state.BaseUrl}`;
  };
  getAllUtentiData1 = () => {
    const url = `${this.getUtentiUrl()}/cerca/all`;
    console.log('getAllUtentiData', url);
    return axios.get(url);
  };
  getAllUtentiData = () => {
    const BasicAuthHeader =
      'Basic ' + window.btoa(AutenticationService.getToken());
    const url = `${this.getUtentiUrl()}/cerca/all`;
    return axios.get(url, {
      headers: {
        authorization: BasicAuthHeader,
        token: AutenticationService.getToken(),
      },
    });
  };
  getUtenteCodice = (codice) => {
    const url = `${this.getUtentiUrl()}/cerca/codice/${codice}`;
    console.log('getUtenteCodice', url);
    return axios.get(url);
  };
  deleteUtenteByCode = (codice) => {
    return axios.get(`${this.getUtentiUrl()}/elimina/codice/${codice}`);
  };

  insUtente1 = (cliente) => {
    const url = `${this.getUtentiUrl()}/inserisci`;
    console.log('insUtente1', url);
    return axios.post(url, cliente);
  };

  insUtente = (dati) => {
    const BasicAuthHeader =
      'Basic ' + window.btoa('claudio' + ':' + 'manno');
    const url = `${this.getUtentiUrl()}/inserisci`;
    return axios.post(url, dati, {
      headers: {
        authorization: BasicAuthHeader,
      },
    });
  };
}

export default new UtentiService();
